export const CHECK_ACCOUNT = 'CHECK_ACCOUNT';
export const SEND_OTP = 'SEND_OTP';
export const SEND_WALLET = 'SEND_WALLET';
